import { Routes } from '@angular/router';
import { FocusReadingPage } from './focus-reading-page/focus-reading-page';
import { FogReadingPage } from './fog-reading-page/fog-reading-page';
import { ReadingBasisHomeworkModePerSoundPage } from './reading-basis-homework-mode-per-sound-page/reading-basis-homework-mode-per-sound-page';
import { ReadingBasisHomeworkModePerSoundfootPage } from './reading-basis-homework-mode-per-soundfoot-page/reading-basis-homework-mode-per-soundfoot-page';
import { ReadingBasisHomeworkModePerWordPage } from './reading-basis-homework-mode-per-word-page/reading-basis-homework-mode-per-word-page';
import { ReadingBasisInstructionModePerSoundPage } from './reading-basis-instruction-mode-per-sound-page/reading-basis-instruction-mode-per-sound-page';
import { ReadingBasisInstructionModePerSoundfootPage } from './reading-basis-instruction-mode-per-soundfoot-page/reading-basis-instruction-mode-per-soundfoot-page';
import { ReadingBasisInstructionModePerWordPage } from './reading-basis-instruction-mode-per-word-page/reading-basis-instruction-mode-per-word-page';
import { ReadingBasisPage } from './reading-basis-page';

export const mechanicReadingBasisRoutes: Routes = [
  {
    path: '',
    component: ReadingBasisPage,
  },
  {
    path: 'focus',
    component: FocusReadingPage,
  },
  {
    path: 'fog',
    component: FogReadingPage,
  },
  {
    path: 'instruction-mode-per-sound',
    component: ReadingBasisInstructionModePerSoundPage,
  },
  {
    path: 'instruction-mode-per-soundfoot',
    component: ReadingBasisInstructionModePerSoundfootPage,
  },
  {
    path: 'instruction-mode-per-word',
    component: ReadingBasisInstructionModePerWordPage,
  },
  {
    path: 'homework-mode-per-sound',
    component: ReadingBasisHomeworkModePerSoundPage,
  },
  {
    path: 'homework-mode-per-soundfoot',
    component: ReadingBasisHomeworkModePerSoundfootPage,
  },
  {
    path: 'homework-mode-per-word',
    component: ReadingBasisHomeworkModePerWordPage,
  },
];
